// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/sweetalert2/dist/sweetalert2.min.css
// module id = ./node_modules/sweetalert2/dist/sweetalert2.min.css
// module chunks = 0